/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Company identity fetched server-side from the public French company registry (recherche-entreprises.api.gouv.fr)
 * @export
 * @interface EnterpriseDto
 */
export interface EnterpriseDto {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDto
     */
    siret?: string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDto
     */
    raisonSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDto
     */
    adresseLigne1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDto
     */
    commune?: string | null;
    /**
     * INSEE legal category code (informative, not mapped to the internal referential)
     * @type {string}
     * @memberof EnterpriseDto
     */
    natureJuridiqueCode?: string | null;
    /**
     * NAF/APE code (e.g. 68.32A = property administration)
     * @type {string}
     * @memberof EnterpriseDto
     */
    activitePrincipale?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDto
     */
    estActive?: boolean;
}

/**
 * Check if a given object implements the EnterpriseDto interface.
 */
export function instanceOfEnterpriseDto(value: object): value is EnterpriseDto {
    return true;
}

export function EnterpriseDtoFromJSON(json: any): EnterpriseDto {
    return EnterpriseDtoFromJSONTyped(json, false);
}

export function EnterpriseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnterpriseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'siret': json['siret'] == null ? undefined : json['siret'],
        'raisonSociale': json['raisonSociale'] == null ? undefined : json['raisonSociale'],
        'adresseLigne1': json['adresseLigne1'] == null ? undefined : json['adresseLigne1'],
        'codePostal': json['codePostal'] == null ? undefined : json['codePostal'],
        'commune': json['commune'] == null ? undefined : json['commune'],
        'natureJuridiqueCode': json['natureJuridiqueCode'] == null ? undefined : json['natureJuridiqueCode'],
        'activitePrincipale': json['activitePrincipale'] == null ? undefined : json['activitePrincipale'],
        'estActive': json['estActive'] == null ? undefined : json['estActive'],
    };
}

export function EnterpriseDtoToJSON(json: any): EnterpriseDto {
    return EnterpriseDtoToJSONTyped(json, false);
}

export function EnterpriseDtoToJSONTyped(value?: EnterpriseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siret': value['siret'],
        'raisonSociale': value['raisonSociale'],
        'adresseLigne1': value['adresseLigne1'],
        'codePostal': value['codePostal'],
        'commune': value['commune'],
        'natureJuridiqueCode': value['natureJuridiqueCode'],
        'activitePrincipale': value['activitePrincipale'],
        'estActive': value['estActive'],
    };
}

